var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import { Svg } from './Svg';
var UtilityWaterIcon = function (props) { return (React.createElement(Svg, __assign({}, props),
    React.createElement("g", null,
        React.createElement("path", { strokeLinejoin: "round", strokeWidth: "1.5", d: "M18.8461538,14.6923077 C18.8461538,18.5158174 15.7465867,21.6153845 11.9230769,21.6153845 C8.09956717,21.6153845 5,18.5158174 5,14.6923077 C5,10.0769231 10.7692308,2 11.9230769,2 C13.0769231,2 18.8461538,10.0769231 18.8461538,14.6923077 Z M11.9230769,17 C10.6485737,17 9.61538462,15.966811 9.61538462,14.6923077" })))); };
export var UtilityWater = styled(UtilityWaterIcon)(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
//# sourceMappingURL=UtilityWater.js.map